import { useQuery } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { getUser } from 'modules/settings/api';

export const useQueryUser = (userId: number | null) => {
  const { data, isError, isLoading, refetch, isFetching } = useQuery(
    QUERY_KEYS.SETTINGS_PROFILE_USER,
    () => getUser(userId),
    { enabled: !!userId, cacheTime: 0 },
  );

  return {
    userData: data,
    userLoading: isLoading,
    userError: isError,
    userRefetch: refetch,
    userFetching: isFetching,
  };
};
